







import { Component, Vue } from "vue-property-decorator";
import { isIEBrowser } from "./utils";
@Component
export default class App extends Vue {
  private created() {

    // Check for IE
    if (isIEBrowser()) {
      this.$router.push({ name: "ie" });
      return;
    }
  }
}
